module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_adultbirthday-05f6b395f8bb9923c45c9d46342ea3f6.jpg";